function SingleCreditBullet({title}) {
  return (
    <li
      style={{
        color: "white",
        fontFamily: "Georgia",
        fontSize: "1.1rem",
        paddingLeft: 0,
        fontWeight: "bold",
      }}
    >
      {title}
    </li>
  )
}

export default SingleCreditBullet;
